export type FabricShareWxOptions = {
  /**
   * 分享标题
   */
  title: string;
  /**
   * 分享描述
   */
  desc: string;
  /**
   * 分享链接
   */
  link: string;
  /**
   * 分享类型,music、video, img, text或link，选填 不填默认为link
   * @default 'link'
   */
  type?: 'link' | 'music' | 'video' | 'img' | 'text';
  /**
   * 发送到朋友圈——timeline(默认);发送到聊天界面——session;添加到微信收藏——favorite
   */
  scene?: string;
  /**
   * 分享图标
   * @default APP 默认的图标
   */
  imgUrl?: string;
  /**
   * 如果type是music或video，则要提供数据链接，选填 默认为空
   */
  dataUrl?: string;
  /**
   * 分享的base64格式图片，优先级高于imgUrl 选填 默认 App 图标
   * @default APP 默认的图标
   */
  imgBase64?: string;
};

/**
 * 分享操作执行成功,
 * 1: 成功; 0:取消
 */
export type FabricShareWxCallbackData = '0' | '1';

/**
 * 微信分享
 */
export type FabricShareWxApi = (
  option: FabricShareWxOptions
) => Promise<FabricShareWxCallbackData>;

export const uniformTypeIdentifier = {
  PDF: 'com.adobe.pdf',
  QuickTimeMovies: 'com.apple.quicktime-movie',
  HtmlDocuments: 'public.html',
  JPEGFiles: 'public.jpeg',
};

/**
 * IOS文件分享
 */
export type FabricShareDocumentApi = (
  option: FabricShareDocumentOption
) => Promise<{}>;
export type FabricShareDocumentOption<T = keyof typeof uniformTypeIdentifier> =
  {
    url: string;
    type: T;
  };

/**
 * 分享操作执行成功,
 * 0:取消; 1: 成功; 2:失败
 */
export type FabricShareDocumentCallbackData = '0' | '1' | '2';
